import EventManager from "../../../manager/event_manager";
import MVVMBase from "../../../framework/core/mvvm/mvvm_base";
import ComponentBase from "../../public/component/component_base";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubItemBase extends ComponentBase {

    @property(MVVMBase)
    mvvmBase : MVVMBase = null;

    private _itemIndex : number;
    get itemIndex() : number {
        return this._itemIndex;
    }
    set itemIndex(v : number) {
        this._itemIndex = v;
    }
    
    protected dispatchEvent(event : string,...data:any[]){

        EventManager.instance.dispatch(event,this.itemIndex,...data);
    }

    protected registerEvent(event : string,callback : Function){

        EventManager.instance.on(event,callback,this,true);
    }
    

 
}
